<template>
  <v-highlight
    :product="product"
    :trailer-mode="TrailerMode.TILE"
    class="c-highlight--outline c-highlight--hero"
    play-on-hover
  >
    <h3 class="o-typography__headline1 u-bold u-text-transform-none u-ellipsis">
      {{ mainTitle }}
    </h3>
    <div class="u-flex">
      <v-badge
        :product="product"
        :counting="isFuture"
      ></v-badge>
    </div>
    <p class="o-typography__body1 u-desktop-only u-bold u-ellipsis-3-lines">
      {{ product.lead | truncate }}
    </p>
    <template #buttons>
      <v-play-product
        v-if="isPlayable || isFuture"
        autoplay-redirect
        outline
        :product="product"
        :show-label="!$window.isMobileView"
      ></v-play-product>
    </template>
  </v-highlight>
</template>
<script>
  import { VBadge, VHighlight, VPlayProduct } from '@/index/shared/components';
  import { meta, truncate } from '@/index/shared/filters';
  import { productMixin } from '@/index/shared/mixins';
  import { heroMainTitleMixin, randomProductMixin } from '@/index/components/section/mixins';
  import { TrailerMode } from '@/shared/enums';

  export default {
    components: {
      VBadge,
      VHighlight,
      VPlayProduct,
    },
    enums: {
      TrailerMode,
    },
    filters: {
      meta,
      truncate,
    },
    mixins: [
      productMixin,
      randomProductMixin,
      heroMainTitleMixin,
    ],
  };
</script>
